import { render, staticRenderFns } from "./KzsViewAdditionalSettings.vue?vue&type=template&id=29f431c4"
import script from "./KzsViewAdditionalSettings.vue?vue&type=script&lang=js"
export * from "./KzsViewAdditionalSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports